import { render, staticRenderFns } from "./TravelInfo.vue?vue&type=template&id=0568f1c9&scoped=true"
import script from "./TravelInfo.vue?vue&type=script&lang=js"
export * from "./TravelInfo.vue?vue&type=script&lang=js"
import style0 from "./TravelInfo.vue?vue&type=style&index=0&id=0568f1c9&prod&lang=css"
import style1 from "./TravelInfo.vue?vue&type=style&index=1&id=0568f1c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0568f1c9",
  null
  
)

export default component.exports